import React from 'react';
import './FileGrid.css';
import FileItem from '../FileItem/FileItem';

const FileGrid = ({ files, selectedItems, onItemClick, onItemDoubleClick, onContainerClick, onDragStart, onDragOver, onDrop, onContainerDragOver, onContainerDrop }) => (
    <div className='file-grid-container' onClick={onContainerClick} onDragOver={onContainerDragOver} onDrop={onContainerDrop}>
        <div className="file-grid">
            {files.map((file, index) => (
                <FileItem 
                    key={file.type+file.id} 
                    file={file}
                    isSelected={selectedItems.some(x => x.id == file.id && x.type == file.type)}
                    onClick={onItemClick}
                    onDoubleClick={onItemDoubleClick}
                    onDragStart={onDragStart}
                    onDragOver={onDragOver}
                    onDrop={onDrop}
                />
            ))}
        </div>
    </div>
);

export default FileGrid;